import { render, staticRenderFns } from "./CompanyCombo.vue?vue&type=template&id=49d16707&"
import script from "./CompanyCombo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CompanyCombo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports